import type { GQL_ID } from '@@partner:types:graphql'
import type {
  ApplyPromocodeMutation,
  ApplyPromocodeMutationVariables
} from '@@partner:graphql/mutation/order/applyPromocode.gql'
import type {
  UnapplyPromocodeMutation,
  UnapplyPromocodeMutationVariables
} from '@@partner:graphql/mutation/order/unapplyPromocode.gql'

import React, { useState, useCallback } from 'react'
import { useMutation } from '@apollo/client'
import { makeGraphQLErrorNotification } from '@@partner:helpers/notification'

import { Input, InputGroup } from 'rsuite'

import { GQL_MUTATION_APPLY_PROMOCODE } from '@@partner:graphql/mutation/order/applyPromocode.gql'
import { GQL_MUTATION_UNAPPLY_PROMOCODE } from '@@partner:graphql/mutation/order/unapplyPromocode.gql'

export interface InlinePromocodeProps {
  order_id: GQL_ID
  promocode_id?: GQL_ID
  promocode?: string
  onPromocodeApplied?: (promocode_id: GQL_ID) => void
}

export default function InlinePromocode ({
  order_id,
  promocode_id,
  promocode: defaultPromocode
}: InlinePromocodeProps) {
  const [ promocode, setPromocode ] = useState(defaultPromocode)

  const [ applyPromocode, { loading } ] = useMutation<
    ApplyPromocodeMutation,
    ApplyPromocodeMutationVariables
  >(GQL_MUTATION_APPLY_PROMOCODE)

  const [ unapplyPromocode ] = useMutation<
    UnapplyPromocodeMutation,
    UnapplyPromocodeMutationVariables
  >(GQL_MUTATION_UNAPPLY_PROMOCODE)

  const handleApplyPromocodeClick = useCallback(
    (event: React.SyntheticEvent) => {
      event.preventDefault()

      if (promocode && promocode.length > 0) {
        applyPromocode({
          variables: {
            promocode,
            order_id
          }
        }).catch(makeGraphQLErrorNotification('Не удалось применить промокод'))
      }
    },
    [ applyPromocode, order_id, promocode ]
  )

  const handleDropPromocodeClick = useCallback(() => {
    if (promocode_id) {
      unapplyPromocode({
        variables: {
          promocode_id,
          order_id
        }
      }).catch(makeGraphQLErrorNotification('Не удалось отключить промокод'))
    }
  }, [ order_id, promocode_id, unapplyPromocode ])

  return (
    <div className="InlinePromocode">
      <InputGroup>
        <Input
          onPressEnter={handleApplyPromocodeClick}
          placeholder="Промокод"
          value={promocode}
          onChange={setPromocode}
        />
        <InputGroup.Button
          color="violet"
          loading={loading}
          onClick={handleApplyPromocodeClick}
        >
          Применить
        </InputGroup.Button>
        {promocode_id && (
          <InputGroup.Button color="red" onClick={handleDropPromocodeClick}>
            Отключить
          </InputGroup.Button>
        )}
      </InputGroup>
    </div>
  )
}
